<atom-modal-wrapper [modalId]="modalId" size="xl" [modalTemplate]="auditDiff">
    <ng-template #auditDiff>
        <organism-modal [modalTitle]="getTitle()">
            <div class="flex-grow-1 d-flex flex-column overflow-hidden h-100">
                @if (auditEventNoData) {
                    <div class="flex-grow-1 d-flex justify-content-center align-items-center">
                        <p class="text-muted">{{ TRANSLATION_AUDIT_DIFF_NO_DATA_FOUND | translateTokenisedString }}</p>
                    </div>
                } @else {
                    <div class="flex-grow-1 d-flex flex-column overflow-hidden">
                        @if (differences.length) {
                            <wdx-alert
                                [rounded]="false"
                                themeColor="warning"
                                [allowFlex]="false"
                                data-cy="audit-differences-alert"
                            >
                                <div class="d-flex justify-content-between">
                                    <div class="d-flex align-items-start">
                                        <wdx-icon
                                            class="me-2"
                                            data-cy="audit-differences-icon"
                                            icon="triangle-exclamation"
                                        ></wdx-icon>
                                        <div>
                                            <p
                                                class="mb-1"
                                                data-cy="audit-differences-message"
                                            >
                                                {{
                                                    differences.length
                                                        | i18nPlural
                                                            : AUDIT_DIFFERENCES_MAPPING
                                                        | translateTokenisedString
                                                            : {
                                                                  count:
                                                                      '' +
                                                                      differences.length
                                                              }
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </wdx-alert>
                        }
                        <div class="bg-muted border-bottom sticky-top z-1">
                            <wdx-tabs class="border-bottom-0">
                                <li wdxTab (click)="showAdvancedMode = false">
                                    <a wdxTabLink [class.active]="!showAdvancedMode">
                                        {{ TRANSLATION_AUDIT_DIFF_TAB_TABLE | translateTokenisedString }}
                                    </a>
                                </li>
                                <li wdxTab (click)="showAdvancedMode = true">
                                    <a wdxTabLink [class.active]="showAdvancedMode">
                                        {{ TRANSLATION_AUDIT_DIFF_TAB_JSON | translateTokenisedString }}
                                    </a>
                                </li>
                                <wdx-tab-actions>
                                    <wdx-switch
                                        [label]="TRANSLATION_AUDIT_DIFF_SHOW_ONLY_DIFF | translateTokenisedString"
                                        [toggled]="showOnlyDifferences"
                                        (toggledChanged)="showOnlyDifferences = $event"
                                    ></wdx-switch>
                                </wdx-tab-actions>
                            </wdx-tabs>
                        </div>
                        @if (showAdvancedMode) {
                            <div class="flex-grow-1 d-flex flex-column overflow-hidden">
                                <wdx-json-diff
                                    [leftData]="showOnlyDifferences ? auditEventFilteredData?.pre : auditEventRawData?.pre"
                                    [rightData]="showOnlyDifferences ? auditEventFilteredData?.post : auditEventRawData?.post"
                                ></wdx-json-diff>
                            </div>
                        } @else {
                            <div class="flex-grow-1 d-flex flex-column overflow-hidden">
                                <ag-grid-angular
                                    wdxAgGridTheme
                                    class="flex-grow-1 w-100"
                                    [rowData]="filteredAuditEventComparisonRows"
                                    [columnDefs]="columnDefs"
                                    [defaultColDef]="defaultColDef"
                                >
                                </ag-grid-angular>
                            </div>
                        }
                    </div>
                }
            </div>
        </organism-modal>
    </ng-template>
</atom-modal-wrapper>
